import React from 'react'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import useStores from '../../stores/useStore'
import { useTranslation } from 'react-i18next'
import { Observer } from 'mobx-react'

const StyledScanViewSwitch = styled.div`
  margin-bottom: 25px;
  font-weight: bold;
`
const InventoryArticleScanSwitch = () => {
    const { inventoryStore } = useStores()
    const { t } = useTranslation();
    return (<Observer>{() => (
        <StyledScanViewSwitch>
            <Form.Check
                type="switch"
                label={t('inventory:switchScanModus')}
                onChange={(e) => { inventoryStore.setScanModus(e.target.checked) }}
                id="inventory-scan-switch"
                checked={inventoryStore.scanModus}
            />
        </StyledScanViewSwitch>
    )}</Observer>)
}

export default InventoryArticleScanSwitch